<template>
  <div class="firstpage">
    <!-- <Firstpage ref="Firstpage" v-bind="$attrs" v-on="$listeners"/> -->
    第一屏
  </div>
</template>

<script>
import { isPortraitFun, getUrlKey } from "@/utils/utils.js";
// import Firstpage from "./Firstpage.vue";
export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      minip: false,
    };
  },
  mounted: function () {},
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.firstpage {
  position: relative;
  height: 100vh;
  width: 100%;
  user-select: none;
  img{
    width: 100%;
    height: 100vh;
    object-fit: cover;
  }
  .icons {
    .playicon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 50px;
      height: 50px;
      background: url("../assets/images/play.png") no-repeat;
      z-index: 10;
      cursor: pointer;
    }
  }
  .txt-container {
    width: 21%;
    position: absolute;
    left: 12%;
    top: 13%;
    // .btn-container {
    //   display: flex;
    //   justify-content: space-between;
    //   width: 100%;
    //   margin-top: 8%;
    //   a {
    //     width: 48%;
    //   }
    // }
  }
  .city {
    width: 20%;
    position: absolute;
    bottom: 15vh;
    left: 12%;
  }
  .swiper-button-prev,
    .swiper-button-next {
      position: absolute;
      color: #fff;
    }
  ::v-deep .swiper-pagination-bullet {
    width: 40px;
    height: 2px;
    display: inline-block;
    border-radius: 0;
    background: #fff;
    color: #fff;
    opacity: 1;
  }
  ::v-deep .swiper-pagination-bullet-active{
    background: #000;
  }
  ::v-deep .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 40px;
    left: 30px;
    width: 100%;
    position: absolute;
    color: #fff;
    z-index: 1;
}
  @media screen and (orientation: portrait) {
    position: relative;
    height: 100vh;
    width: 100%;
    user-select: none
      no-repeat;
    .txt-container {
      // margin-top: 5%;
      position: absolute;
      top: 7%;
      left: 50%;
      transform: translateX(-50%);
      width: 70%;
    //   .btn-container {
    //     display: flex;
    //     justify-content: space-between;
    //     width: 100%;
    //     margin-top: 5%;
    //   }
    }
    .city {
        width: 45%;
        position: absolute;
        bottom: 16vh;
        left: 50%;
        transform: translateX(-50%);
    }
    ::v-deep .swiper-container-horizontal > .swiper-pagination-bullets {
      bottom: 15vh;
    }
  }
}
</style>
